import { RouteRecordRaw } from 'vue-router'

// 题库练习模块路由
const exercisesRoutes: RouteRecordRaw = {
  path: '/exercises',
  name: 'Exercises',
  component: () => import('@/views/Exercises/index.vue'),
  meta: {
    title: '题库练习',
    requiresAuth: true
  },
  children: [
    {
      path: '',
      name: 'ExerciseCatalog',
      component: () => import('@/views/Exercises/ExerciseCatalog.vue'),
      meta: {
        title: '题库列表',
        requiresAuth: true
      }
    },
    {
      path: 'list',
      name: 'ExerciseList',
      component: () => import('@/views/Exercises/ExerciseList.vue'),
      meta: {
        title: '练习列表',
        requiresAuth: true
      }
    },
    {
      path: 'detail/:id',
      name: 'ExerciseDetail',
      component: () => import('@/views/Exercises/ExerciseDetail.vue'),
      meta: {
        title: '练习详情',
        requiresAuth: true
      }
    },
    {
      path: 'daily-challenge',
      name: 'DailyChallenge',
      component: () => import('@/views/MicroAppContainer.vue'),
      meta: {
        title: '每日挑战',
        microApp: 'app1',
        requiresAuth: true
      }
    },
    {
      path: 'practice-history',
      name: 'PracticeHistory',
      component: () => import('@/views/MicroAppContainer.vue'),
      meta: {
        title: '练习历史',
        microApp: 'app1',
        requiresAuth: true
      }
    },
    {
      path: 'statistics',
      name: 'PracticeStatistics',
      component: () => import('@/views/MicroAppContainer.vue'),
      meta: {
        title: '练习统计',
        microApp: 'app1',
        requiresAuth: true
      }
    },
    {
      path: 'weak-points',
      name: 'WeakPoints',
      component: () => import('@/views/MicroAppContainer.vue'),
      meta: {
        title: '薄弱知识点',
        microApp: 'app1',
        requiresAuth: true
      }
    },
    {
      path: 'resume/:id',
      name: 'ResumeExercise',
      component: () => import('@/views/MicroAppContainer.vue'),
      meta: {
        title: '继续练习',
        microApp: 'app1',
        requiresAuth: true
      }
    },
    {
      path: 'recommended/:id',
      name: 'RecommendedExercise',
      component: () => import('@/views/MicroAppContainer.vue'),
      meta: {
        title: '推荐练习',
        microApp: 'app1',
        requiresAuth: true
      }
    },
    {
      path: 'online-exam',
      name: 'OnlineExam',
      component: () => import('@/views/Exercises/OnlineExam.vue'),
      meta: {
        title: '在线考试',
        requiresAuth: true
      }
    },
    {
      path: 'online-exam/notice',
      name: 'OnlineExamNotice',
      component: () => import('@/views/Exercises/ExamNotice.vue'),
      meta: {
        title: '视频监考须知',
        requiresAuth: true
      }
    },
    {
      path: 'online-exam/take/:examId',
      name: 'OnlineExamTaking',
      component: () => import('@/views/Exercises/ExamTaking.vue'),
      meta: {
        title: '在线考试 - 答题',
        requiresAuth: true
      }
    },
    {
      path: 'online-exam/finish',
      name: 'OnlineExamFinish',
      component: () => import('@/views/Exercises/ExamFinished.vue'),
      meta: {
        title: '在线考试 - 结束',
        requiresAuth: true
      }
    },
    {
      path: 'online-exam/score',
      name: 'OnlineExamScore',
      component: () => import('@/views/Exercises/ExamScore.vue'),
      meta: {
        title: '在线考试 - 成绩',
        requiresAuth: true
      }
    },
    {
      path: 'mobile-monitor',
      name: 'MobileMonitor',
      component: () => import('@/views/Exercises/MobileMonitor.vue'),
      meta: {
        title: '手机端监控',
        requiresAuth: false // 移动端可能不需要登录验证
      }
    }
  ]
}

export default exercisesRoutes 